__turbopack_context__.v({
  "helpBtn": "HelpSection-module__PiOEpG__helpBtn",
  "helpOverlay": "HelpSection-module__PiOEpG__helpOverlay",
  "helpSection": "HelpSection-module__PiOEpG__helpSection",
  "helpTitle": "HelpSection-module__PiOEpG__helpTitle",
});
